import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { StyledEngineProvider } from '@mui/material/styles';
import { Provider } from "react-redux";
import { SocketProvider } from './socket';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { RoleProvider } from './contexts/RoleContext';
import { UserProvider } from './contexts/UserContext';
import { OrderProvider } from './contexts/OrderContext';
import { FloorProvider } from './contexts/FloorContext';
import { TableProvider } from './contexts/TableContext';
import { ComboProvider } from './contexts/CombosContext';
import { ReportProvider } from './contexts/ReportContext';
import { CourseProvider } from './contexts/CourseContext';
import { ChoiceProvider } from './contexts/ChoicesContext';
import { DeviceProvider } from './contexts/DevicesContext';
import { ProductProvider } from './contexts/ProductContext';
import { PrinterProvider } from './contexts/PrinterContext';
import { PaymentProvider } from './contexts/PaymentContext';
import { CategoryProvider } from './contexts/CategoryContext';
import { CustomerProvider } from './contexts/CustomerContext';
import { DiscountProvider } from './contexts/DiscountContext';
import { ModifierProvider } from './contexts/ModifiersContext';
import { UserGroupProvider } from './contexts/UserGroupContext';
import { IngredientProvider } from './contexts/IngredientContext';
import { RestaurantProvider } from './contexts/RestaurantContext';
import { CompanySettingProvider } from './contexts/CompanySettingContext';
import store from './store';
import { AuditProvider } from './contexts/AuditContext';
import { PermissionProvider } from './contexts/PermissionContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <SocketProvider>
        <PermissionProvider>
          <AuditProvider>
            <RestaurantProvider>
              <UserProvider>
                <PaymentProvider>
                  <UserGroupProvider>
                    <OrderProvider>
                      <CourseProvider>
                        <CategoryProvider>
                          <CustomerProvider>
                            <IngredientProvider>
                              <ProductProvider>
                                <DiscountProvider>
                                  <ChoiceProvider>
                                    <ComboProvider>
                                      <ModifierProvider>
                                        <CompanySettingProvider>
                                          <PrinterProvider>
                                            <DeviceProvider>
                                              <RoleProvider>
                                                <FloorProvider>
                                                  <TableProvider>
                                                    <ReportProvider>
                                                      <Provider store={store}>
                                                        <StyledEngineProvider>
                                                          <App />
                                                        </StyledEngineProvider>
                                                      </Provider>
                                                    </ReportProvider>
                                                  </TableProvider>
                                                </FloorProvider>
                                              </RoleProvider>
                                            </DeviceProvider>
                                          </PrinterProvider>
                                        </CompanySettingProvider>
                                      </ModifierProvider>
                                    </ComboProvider>
                                  </ChoiceProvider>
                                </DiscountProvider>
                              </ProductProvider>
                            </IngredientProvider>
                          </CustomerProvider>
                        </CategoryProvider>
                      </CourseProvider>
                    </OrderProvider>
                  </UserGroupProvider>
                </PaymentProvider>
              </UserProvider>
            </RestaurantProvider>
          </AuditProvider>
        </PermissionProvider>
      </SocketProvider>
    </AuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
